// Vendor libraries
import { EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { distinctUntilChanged } from 'rxjs';
import { debounceTime, takeWhile } from 'rxjs/operators';
// Constants / utils
import { LEGACY_REPORT_TYPES } from 'CustomPDFReportsApp/ts/constants';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { LEGACY_DATA_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { REPORT_TYPE_OPTIONS } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/constants';
// Services
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { GenerateReportFolderableCollectionService } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/services/generate-report-folderable-collection-ajax.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { CustomPdfReportDataSourceEnum } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-data-source.enum';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { GenerateReportsModalSortColumn } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/enums/generate-reports-modal-sort-column.enum';
// Actions
import { resetSelectedReport } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { incrementCurrentWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
// Reducers
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
// Selectors
import { getCurrentWizardStepIndex, getPrimarySecurity, getSavedAnalysisPlanId, getSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
// Components
import { PreviewImageModalComponent } from 'NewAngular/features/components/modals/preview-image-modal/preview-image-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/services/generate-report-folderable-collection-ajax.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "FoldersApp/features/folders-shared/folderable-column-headers-component/folderable-column-headers.component";
import * as i8 from "@angular/forms";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i14 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/generate-modal-delete-modal/generate-modal-delete-modal.component";
import * as i15 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/generate-modal-folderable-list-item/generate-modal-folderable-list-item.component";
const _c0 = a0 => ({ "visibility": a0 });
const _c1 = () => ({});
const _c2 = () => ({ visibility: "hidden" });
const _c3 = a0 => ({ id: null, name: "Report Templates", permissions: a0 });
const _c4 = (a0, a1) => ({ folderable: a0, ancestorInfo: a1 });
function _forTrack0($index, $item) { return this.trackFolderable($item); }
function CustomPdfReportFolderModalComponent_label_10_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 30)(1, "input", 31);
    i0.ɵɵlistener("change", function CustomPdfReportFolderModalComponent_label_10_Template_input_change_1_listener() { const option_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setOwnerOption(option_r3)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 32)(3, "span", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", option_r3.value)("checked", option_r3.checked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerText", option_r3.label);
} }
function CustomPdfReportFolderModalComponent_label_15_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 30)(1, "input", 31);
    i0.ɵɵlistener("change", function CustomPdfReportFolderModalComponent_label_15_Template_input_change_1_listener() { const option_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setReportTypeOption(option_r6)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 32)(3, "span", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", option_r6.value)("checked", option_r6.checked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerText", option_r6.label);
} }
function CustomPdfReportFolderModalComponent_Conditional_25_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("click", function CustomPdfReportFolderModalComponent_Conditional_25_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.reportNameFilterInput.setValue("")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function CustomPdfReportFolderModalComponent_Conditional_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-search");
} }
function CustomPdfReportFolderModalComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵlistener("setSort", function CustomPdfReportFolderModalComponent_div_30_Template_div_setSort_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setSort($event)); });
    i0.ɵɵelement(1, "th", 37);
    i0.ɵɵelementStart(2, "div", 38)(3, "label", 39);
    i0.ɵɵelement(4, "input", 40)(5, "span", 32);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("columnConfig", ctx_r3.SAVED_ITEM_COLUMN_CONFIG)("sortableColumns", ctx_r3.GenerateReportsModalSortColumn)("sortColumn", ctx_r3.sortColumn)("sortDirection", ctx_r3.sortDirection);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(5, _c2));
} }
function CustomPdfReportFolderModalComponent_Conditional_32_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "span");
    i0.ɵɵtext(2, "There are no items.");
    i0.ɵɵelementEnd()();
} }
function CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_For_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-generate-modal-folderable-list-item", 44);
    i0.ɵɵlistener("errorHandler", function CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_For_1_ng_template_1_Template_ycn_generate_modal_folderable_list_item_errorHandler_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r3 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r3.errorText = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r10 = ctx.folderable;
    const ancestorInfo_r11 = ctx.ancestorInfo;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("folderable", subItem_r10)("ancestorInfo", ancestorInfo_r11)("baseResourceType", ctx_r3.baseResourceType);
} }
function CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 43);
    i0.ɵɵtemplate(1, CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_For_1_ng_template_1_Template, 1, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderable_r12 = ctx.$implicit;
    const listItemFragment_r13 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", listItemFragment_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c4, folderable_r12, i0.ɵɵpureFunction1(3, _c3, i0.ɵɵpureFunction0(2, _c1))));
} }
function CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 45);
    i0.ɵɵtext(1, " To change the timeframe and to hide or display the benchmark in the Level Chart, update selections on the security's Quote tab before generating your Tearsheet. ");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_For_1_Template, 3, 8, null, null, _forTrack0, true);
    i0.ɵɵtemplate(2, CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_p_2_Template, 2, 0, "p", 42);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r3.filteredReports);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.currentReportTypeInternalName === ctx_r3.tearsheetsInternalName);
} }
function CustomPdfReportFolderModalComponent_Conditional_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CustomPdfReportFolderModalComponent_Conditional_32_Conditional_0_Template, 3, 0, "div", 41)(1, CustomPdfReportFolderModalComponent_Conditional_32_Conditional_1_Template, 3, 1);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r3.folderableCollectionService.loading && ctx_r3.folderableCollectionService.items.length === 0 ? 0 : 1);
} }
function CustomPdfReportFolderModalComponent_Conditional_33_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 46);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const userHasNoDataFragment_r14 = i0.ɵɵreference(37);
    i0.ɵɵproperty("ngTemplateOutlet", userHasNoDataFragment_r14);
} }
function CustomPdfReportFolderModalComponent_Conditional_33_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 46);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const noDataFragment_r15 = i0.ɵɵreference(35);
    i0.ɵɵproperty("ngTemplateOutlet", noDataFragment_r15);
} }
function CustomPdfReportFolderModalComponent_Conditional_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CustomPdfReportFolderModalComponent_Conditional_33_Conditional_0_Template, 1, 1, "ng-container", 46)(1, CustomPdfReportFolderModalComponent_Conditional_33_Conditional_1_Template, 1, 1, "ng-container", 46);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r3.folderableCollectionService.userHasNoData ? 0 : 1);
} }
function CustomPdfReportFolderModalComponent_ng_template_34_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1, " No Reports.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span")(4, "a", 48);
    i0.ɵɵlistener("click", function CustomPdfReportFolderModalComponent_ng_template_34_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r16); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.clearReportFilters()); });
    i0.ɵɵtext(5, "Clear Filters");
    i0.ɵɵelementEnd()()();
} }
function CustomPdfReportFolderModalComponent_ng_template_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1, " No Reports. ");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportFolderModalComponent_Conditional_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 28);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
const OWNER_OPTIONS = [
    {
        label: 'Me',
        value: 'me',
        checked: true,
    },
    {
        label: 'Shared with me',
        value: 'shared_with_me',
        checked: true,
    },
    {
        label: 'Public',
        value: 'public',
        checked: true,
    },
];
/**
 * Custom PDF Report Modal Component
 *
 * This component displays the menu of Custom PDF Reports organized by report type.
 * It is typically the first modal displayed in the Custom PDF Report generation process.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when moving to the next wizard step in the report generation process.
 *
 */
export class CustomPdfReportFolderModalComponent {
    constructor(customPDFReportService, accountsService, featureService, folderableCollectionService, store) {
        this.customPDFReportService = customPDFReportService;
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.folderableCollectionService = folderableCollectionService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.reportNameFilterInput = new FormControl('', { nonNullable: true });
        this.securityId = '';
        this.baseResourceType = null;
        this.modalOpen = false;
        this.currentReportTypeInternalName = '';
        this.tearsheetsInternalName = LEGACY_REPORT_TYPES.TEARSHEET;
        this.ownerOptions = OWNER_OPTIONS;
        this.reportTypeOptions = [];
        this.sortColumn = GenerateReportsModalSortColumn.USER_MODIFY_DATE;
        this.sortDirection = DESC;
        this.selectedReport = null;
        this.submitButtonText = 'Start';
        this.onePageReportTypes = new Set(Object.values(LEGACY_REPORT_TYPES));
        this.isAlive = true;
        this.isReportRegeneration = false;
        this.isReportValidatingOrInvalid = false;
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [GenerateReportsModalSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [GenerateReportsModalSortColumn.USER_MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [GenerateReportsModalSortColumn.OWNER]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.processViewResponse = (response) => {
            this.errorText = undefined;
            if (!this.isReportRegeneration) {
                this.store.dispatch(resetSelectedReport());
            }
            this.filteredReports = response.data.items;
            if (!this.filteredReports.length) {
                if (this.baseResourceType === FolderableType.WATCHLIST) {
                    this.errorText =
                        'The files could not be generated because the security list ' +
                            'does not contain at least one supported security type.';
                }
                else if (this.baseResourceType === FolderableType.ANALYSIS_PLAN) {
                    this.errorText =
                        'No interactive analysis reports have been found; ' +
                            'please create a report with interactive analysis modules ' +
                            'or contact support.';
                }
            }
        };
        this.mapStateToComponent = (state) => {
            const { securityId, securityListGroup } = getPrimarySecurity(state);
            this.isReportRegeneration = state.reportRegeneration;
            this.securityId = securityId ?? '';
            this.securityListGroup = securityListGroup;
            const selectedReport = getSelectedReport(state);
            this.currentReportTypeInternalName = selectedReport?.report_type;
            if (this.securityId?.startsWith('watchlist-')) {
                this.baseResourceType = FolderableType.WATCHLIST;
            }
            else if (getSavedAnalysisPlanId(state) !== null) {
                this.baseResourceType = FolderableType.ANALYSIS_PLAN;
            }
            else {
                this.baseResourceType = null;
            }
            const isRegeneration = this.isReportRegeneration && this.folderableCollectionService.items?.length === 0;
            const reportSelected = Object.keys(selectedReport).length;
            if (state.primarySecurity.securityId &&
                (!reportSelected ||
                    (isRegeneration &&
                        selectedReport.wizard_steps[0].eventName ===
                            CustomPDFReportModalEventName.SHOW_REPORT_MENU_MODAL)) &&
                !this.modalOpen &&
                getCurrentWizardStepIndex(state) === 0) {
                this.errorText = undefined;
                this.fetchReports();
                this.openModal();
            }
            if (Object.keys(selectedReport).length) {
                this.selectedReport = selectedReport;
            }
            else {
                this.selectedReport = null;
            }
            this.submitButtonText = this.currentReportTypeInternalName in this.onePageReportTypes ? 'Generate' : 'Start';
        };
        this.GenerateReportsModalSortColumn = GenerateReportsModalSortColumn;
        this.accountsService.getUserPreferences().subscribe({
            next: ({ use_generic_data_display, custom_pdf_reports_generate_report_modal_filters }) => {
                this.dataSource =
                    !this.featureService.userHasFeatures([LEGACY_DATA_FEATURE]) || use_generic_data_display
                        ? CustomPdfReportDataSourceEnum.DEFAULT
                        : CustomPdfReportDataSourceEnum.LEGACY;
                const filterPrefs = custom_pdf_reports_generate_report_modal_filters;
                if (filterPrefs !== null) {
                    this.reportNameFilterInput.setValue(filterPrefs.name);
                    this.mapStateToOwnerOptions(filterPrefs.owner);
                    this.mapStateToReportTypeOptions(filterPrefs.reportType);
                    this.sortColumn = filterPrefs.sortColumn;
                    this.sortDirection = filterPrefs.sortDirection;
                }
            },
            error: () => {
                this.dataSource = CustomPdfReportDataSourceEnum.LEGACY; // TODO: change this to DEFAULT when data switch happens
                // https://app.asana.com/0/1207424818771538/1207992229300869/f
            },
        });
        this.reportCollectionSubscription = this.folderableCollectionService.viewResponse$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe({
            next: (response) => {
                if (response !== null) {
                    this.processViewResponse(response);
                }
            },
            error: (err) => {
                this.errorText =
                    err.error.error_message ||
                        'Unable to fetch reports. Please refresh the page or contact support.';
                this.filteredReports = [];
                this.folderableCollectionService.loading = false;
            },
        });
    }
    ngOnInit() {
        this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
        this.reportNameFilterInput.valueChanges
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(() => this.fetchReports());
        this.reportTypeOptions = REPORT_TYPE_OPTIONS;
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    mapStateToOwnerOptions(filter) {
        this.ownerOptions = this.ownerOptions.map((option) => {
            return {
                ...option,
                checked: filter[option.value],
            };
        });
    }
    mapStateToReportTypeOptions(filter) {
        if (!filter) {
            return;
        }
        this.reportTypeOptions = this.reportTypeOptions.map((option) => {
            return {
                ...option,
                checked: option.value in filter ? filter[option.value] : true,
            };
        });
    }
    fetchReports(force = false) {
        if (!this.securityId)
            return;
        const ownerFilter = this.ownerOptions.reduce((acc, curr) => {
            acc[curr.value] = curr.checked;
            return acc;
        }, {});
        const reportTypeFilter = this.reportTypeOptions.reduce((acc, curr) => {
            acc[curr.value] = curr.checked;
            return acc;
        }, {});
        const fetchParams = {
            dataSource: this.dataSource,
            name: this.reportNameFilterInput.value,
            baseResourceType: this.baseResourceType,
            owner: ownerFilter,
            reportType: reportTypeFilter,
            sortColumn: this.sortColumn,
            sortDirection: this.sortDirection,
        };
        if (this.baseResourceType === FolderableType.WATCHLIST) {
            fetchParams.securitylistName = this.securityId;
        }
        else {
            fetchParams.securityId = this.securityId;
        }
        this.folderableCollectionService.refreshData(fetchParams, force);
    }
    setOwnerOption(option) {
        this.ownerOptions = this.ownerOptions.map((checkboxOption) => ({
            ...checkboxOption,
            checked: checkboxOption.value === option.value ? !checkboxOption.checked : checkboxOption.checked,
        }));
        this.fetchReports();
    }
    ownerOptionValue(_index, option) {
        return option.value;
    }
    setReportTypeOption(option) {
        this.reportTypeOptions = this.reportTypeOptions.map((checkboxOption) => ({
            ...checkboxOption,
            checked: checkboxOption.value === option.value ? !checkboxOption.checked : checkboxOption.checked,
        }));
        this.fetchReports();
    }
    reportTypeOptionValue(_index, option) {
        return option.value;
    }
    clearSelectedReport() {
        this.store.dispatch(resetSelectedReport());
    }
    clearReportFilters() {
        this.ownerOptions = OWNER_OPTIONS;
        this.reportTypeOptions = REPORT_TYPE_OPTIONS;
        this.reportNameFilterInput.setValue('');
        this.fetchReports();
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorText = undefined;
        this.isReportValidatingOrInvalid = false;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
        this.clearSelectedReport();
    }
    isGenerateableReport(report) {
        return report !== null && report !== undefined && Object.keys(report).length > 0 && 'report_type' in report;
    }
    isReportSelected() {
        return this.isGenerateableReport(this.selectedReport);
    }
    forward() {
        if (this.isReportSelected() && this.isGenerateableReport(this.selectedReport)) {
            if (this.baseResourceType === FolderableType.WATCHLIST) {
                this.isReportValidatingOrInvalid = true;
                this.customPDFReportService
                    .validateReportSecurityList('report_id' in this.selectedReport ? this.selectedReport.report_id : 0, this.securityId, this.securityListGroup, this.selectedReport.report_type in this.onePageReportTypes)
                    .subscribe({
                    next: (response) => {
                        this.errorText = response.message_text;
                        this.isReportValidatingOrInvalid =
                            this.errorText.includes('Security list is too large') ||
                                this.errorText.includes('Selected list has no securities');
                        if (!this.isReportValidatingOrInvalid) {
                            this.closeModal();
                            this.store.dispatch(incrementCurrentWizardStep());
                            this.broadcastWizardStepEvent.emit();
                        }
                    },
                    error: () => {
                        this.errorText = 'Error validating report';
                    },
                });
            }
            else {
                this.closeModal();
                this.store.dispatch(incrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            }
        }
    }
    trackFolderable(folderable) {
        switch (folderable.resourceType) {
            case 'folder': {
                const folder = folderable.item;
                return `folder-${folder.id}`;
            }
            case 'custom_pdf_report': {
                const report = folderable.item;
                return `custompdfreport-${report.id}`;
            }
            default: {
                const report = folderable.item;
                return `legacyreport-${report.report_name}`;
            }
        }
    }
    setSort(sort) {
        this.sortColumn = sort.sortColumn;
        this.sortDirection = sort.sortDirection;
        this.fetchReports();
    }
}
CustomPdfReportFolderModalComponent.ɵfac = function CustomPdfReportFolderModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPdfReportFolderModalComponent)(i0.ɵɵdirectiveInject(i1.CustomPDFReportService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.FeatureService), i0.ɵɵdirectiveInject(i4.GenerateReportFolderableCollectionService), i0.ɵɵdirectiveInject(i5.Store)); };
CustomPdfReportFolderModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPdfReportFolderModalComponent, selectors: [["ycn-custom-pdf-report-folder-modal"]], viewQuery: function CustomPdfReportFolderModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PreviewImageModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewImageModalComponent = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            BulkActionSelectionService,
            GenerateReportFolderableCollectionService,
            FolderExpansionService,
            ToastMessagesService,
            { provide: FolderableCollectionServiceBase, useExisting: GenerateReportFolderableCollectionService },
        ])], decls: 41, vars: 21, consts: [["noDataFragment", ""], ["userHasNoDataFragment", ""], ["listItemFragment", ""], [3, "closeModalHandler", "modalBaseClass", "open", "extraModalClasses"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "row", "wide-gutters", "align-items-end", "pt-12", "pb-10"], [1, "col"], [1, "mb-1"], [1, "form-label", "form-label-thin"], [1, "form-inline"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "form-label", "form-label-thin", 2, "padding-top", "15px"], [1, "modal-section", "pb-10"], [1, "modal-section-header"], [1, "modal-section-title-medium"], [1, "col-4"], [1, "input-group", "ng-scope"], [1, "input-group", "field-input-group"], ["placeholder", "Search", "data-test-id", "name_filter_input", 1, "form-control", "field-input", 3, "formControl"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], [1, "bg-yc-blue-75", 3, "ngStyle"], [1, "page-progress-bar"], [1, "table", "file-table", "table-hover"], ["class", "thead", "ycn-folderable-column-headers", "", 3, "columnConfig", "sortableColumns", "sortColumn", "sortDirection", "setSort", 4, "ngIf"], [1, "tbody"], [3, "loaderMessage"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "errorText", "submitButtonText", "disableSubmission"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", "name", "", 1, "custom-control-input", 3, "change", "id", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "innerText"], [1, "btn", "btn-transparent", 3, "click"], ["ycnIcon", "", 3, "name"], ["ycn-folderable-column-headers", "", 1, "thead", 3, "setSort", "columnConfig", "sortableColumns", "sortColumn", "sortDirection"], [1, "th", "col-1"], [1, "file-td-control", "td"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex", 3, "ngStyle"], ["type", "checkbox", "checked", "true", "name", "securities-list", 1, "custom-control-input"], [1, "get-started-small", "flex-auto"], ["class", "footnote", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "errorHandler", "folderable", "ancestorInfo", "baseResourceType"], [1, "footnote"], [3, "ngTemplateOutlet"], [1, "get-started", "flex-auto"], ["href", "javascript:void(0)", 1, "text-blue", 3, "click"]], template: function CustomPdfReportFolderModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 3);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportFolderModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 4);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportFolderModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 5)(3, "div", 6)(4, "div", 7)(5, "div", 8)(6, "div", 9)(7, "div", 10);
        i0.ɵɵtext(8, "Owner");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 11);
        i0.ɵɵtemplate(10, CustomPdfReportFolderModalComponent_label_10_Template, 4, 3, "label", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9)(12, "div", 13);
        i0.ɵɵtext(13, "Report Type");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵtemplate(15, CustomPdfReportFolderModalComponent_label_15_Template, 4, 3, "label", 12);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(16, "div", 14)(17, "div", 15)(18, "div", 16);
        i0.ɵɵtext(19, "All Report Templates");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 17)(21, "div", 18)(22, "div", 19);
        i0.ɵɵelement(23, "input", 20);
        i0.ɵɵelementStart(24, "div", 21);
        i0.ɵɵtemplate(25, CustomPdfReportFolderModalComponent_Conditional_25_Template, 2, 1, "button", 22)(26, CustomPdfReportFolderModalComponent_Conditional_26_Template, 2, 1, "button", 22);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(27, "div", 23);
        i0.ɵɵelement(28, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 25);
        i0.ɵɵtemplate(30, CustomPdfReportFolderModalComponent_div_30_Template, 6, 6, "div", 26);
        i0.ɵɵelementStart(31, "div", 27);
        i0.ɵɵtemplate(32, CustomPdfReportFolderModalComponent_Conditional_32_Template, 2, 1)(33, CustomPdfReportFolderModalComponent_Conditional_33_Template, 2, 1)(34, CustomPdfReportFolderModalComponent_ng_template_34_Template, 6, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(36, CustomPdfReportFolderModalComponent_ng_template_36_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(38, CustomPdfReportFolderModalComponent_Conditional_38_Template, 1, 1, "ycn-loading-symbol", 28);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(39, "ycn-simple-modal-footer", 29);
        i0.ɵɵlistener("cancelHandler", function CustomPdfReportFolderModalComponent_Template_ycn_simple_modal_footer_cancelHandler_39_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); })("submitHandler", function CustomPdfReportFolderModalComponent_Template_ycn_simple_modal_footer_submitHandler_39_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(40, "ycn-generate-modal-folderable-delete-modal");
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen)("extraModalClasses", "modal-dialog modal-no-border");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngForOf", ctx.ownerOptions)("ngForTrackBy", ctx.ownerOptionValue);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.reportTypeOptions)("ngForTrackBy", ctx.reportTypeOptionValue);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("formControl", ctx.reportNameFilterInput);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.reportNameFilterInput.value ? 25 : 26);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(18, _c0, ctx.folderableCollectionService.loading ? "visible" : "hidden"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.folderableCollectionService.dataParams);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.items ? 32 : !ctx.folderableCollectionService.loading ? 33 : -1);
        i0.ɵɵadvance(6);
        i0.ɵɵconditional(ctx.folderableCollectionService.showLoading && ctx.folderableCollectionService.loading ? 38 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("cancelButtonText", "Reset")("errorText", ctx.errorText)("submitButtonText", ctx.submitButtonText)("disableSubmission", ctx.selectedReport === null && ctx.selectedReport !== i0.ɵɵpureFunction0(20, _c1) || ctx.isReportValidatingOrInvalid || !(ctx.selectedReport == null ? null : ctx.selectedReport.wizard_steps));
    } }, dependencies: [i6.NgForOf, i6.NgIf, i6.NgTemplateOutlet, i6.NgStyle, i7.FolderableColumnHeadersComponent, i8.DefaultValueAccessor, i8.NgControlStatus, i9.IconDirective, i10.LoadingSymbolComponent, i11.ModalBaseComponent, i12.SimpleModalFooterComponent, i13.SimpleModalHeaderComponent, i8.FormControlDirective, i14.GenerateModalDeleteModalComponent, i15.GenerateModalFolderableListItemComponent], encapsulation: 2 });
